import { render } from "./ExampleWrapper.vue?vue&type=template&id=960ae3ac"
import script from "./ExampleWrapper.vue?vue&type=script&lang=js"
export * from "./ExampleWrapper.vue?vue&type=script&lang=js"

import "./ExampleWrapper.vue?vue&type=style&index=0&id=960ae3ac&lang=scss"

import exportComponent from "/media/shared/vue/imgcropper/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__